import React, { useState } from 'react';
import config from '../../config';
import { FormattedMessage } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';
import css from './TopbarMobileMenu.css';
import categoryRoutesConfiguration from '../../categoryRoutes';
import IconChevron from '../IconChevron/IconChevron';
import classNames from 'classnames';

const { categories } = config;

const MobileMenuCategories = () => {
  const routes = categoryRoutesConfiguration();

  const currentCountry = process.env.REACT_APP_COUNTRY_ID || 'pl';

  const getLinkName = (subName) => {
    const route = routes.find(r => r.name === subName);
    return route && route.countries.includes(currentCountry)
      ? subName
      : 'SearchPage';
  };

  // Stan przechowujący aktualnie rozwiniętą kategorię
  const [expandedCategory, setExpandedCategory] = useState(null);

  const toggleCategory = (categoryName) => {
    setExpandedCategory(prev => prev === categoryName ? null : categoryName);
  };

  return (
    <ul className={css.categoriesList}>
      {categories.filter(cat => cat.countries.includes(currentCountry)).map(category => (
        <li key={category.name} className={css.categoryItem}>
          <div
            className={css.category}
            onClick={() => toggleCategory(category.name)}
          >
            <FormattedMessage id={category.name} />
            <IconChevron
              className={classNames(
                css.iconChevron,
                { [css.rotated]: expandedCategory !== category.name }
              )}
            />
          </div>
          {expandedCategory === category.name && (
            <ul className={css.subcategoriesList}>
              {category.subcategories.filter(sub => sub.countries.includes(currentCountry)).map(sub => {
                // Ustalamy nazwę linku – jeśli dany route nie jest dostępny dla bieżącego kraju,
                // funkcja getLinkName zwróci "SearchPage"
                const linkName = getLinkName(sub.name);
                // Szukamy konfiguracji danej trasy
                const matchingRoute = routes.find(r => r.name === sub.name);

                // Jeśli linkName wskazuje fallback ("SearchPage") i znaleziono konfigurację,
                // dodajemy dodatkowy parametr businessCategory
                const linkProps =
                  linkName === 'SearchPage' && matchingRoute
                    ? {
                      to: {
                        search: `businessCategory=${matchingRoute.key}&exact=true`,
                      },
                    }
                    : {};

                return (
                  <li key={sub.name} className={css.subcategoryItem}>
                    <NamedLink name={linkName} {...linkProps} className={css.subLink}>
                      <FormattedMessage id={sub.translation} />
                    </NamedLink>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenuCategories;